// extracted by mini-css-extract-plugin
export default {"itemsContainer":"History_itemsContainer__50wwo","itemList":"History_itemList__6re0e","addNewInput":"History_addNewInput__6AZO+"};